import requests from '../shared/agent'

const LessonPlansService = {
  create: async (bookId, body) => {
    return await requests.post(`/lessonplans/book/${bookId}`, body)
  },
  update: async (id, body) => {
    return await requests.patch(`/lessonplans/${id}`, body)
  },
  delete: async (id) => {
    return await requests.del(`/lessonplans/${id}`)
  }
}

export default LessonPlansService
